import { render, staticRenderFns } from "./startimpression.vue?vue&type=template&id=0c4787f1&scoped=true&lang=html&"
import script from "./startimpression.vue?vue&type=script&lang=js&"
export * from "./startimpression.vue?vue&type=script&lang=js&"
import style0 from "./startimpression.vue?vue&type=style&index=0&id=0c4787f1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4787f1",
  null
  
)

export default component.exports